module.exports = __webpack_public_path__ + "media/images/mypage/mypage_t3-5aade5304b1f64b7c28fca97d44fa537.gif";